import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export const MARKETPLACE_URL = 'http://localhost:8081';

export const marketplaceAxios = axios.create({
  baseURL: MARKETPLACE_URL,
});

export class MarketplaceHttpClient {
  private _api: AxiosInstance;

  public constructor() {
    this._api = marketplaceAxios;
  }

  public get = <T, R = T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> => {
    return this._api.get(url, config).then((x) => x.data);
  };

  public post = <T, B, R = T>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<R> => this._api.post(url, payload, config).then((x) => x.data);
}
